import {createSlice} from '@reduxjs/toolkit';
import {IOneOrder} from '../../types'
import reducers from './reducers'
import extraReducers from './extraReducers'

export * from '../../thunk/mockupsStats';

const MockupsStatsSlice = createSlice({
    name: "mockupsStats",
    initialState: {
        data: {},
        stats:{},
        status: null,
        error: null,
        queryParams: null,
    },
    reducers,
    extraReducers
});
const {actions, reducer} = MockupsStatsSlice;
export const {setMockups, clearFilters} = actions;
export {reducer};
